import { useQuery } from '@tanstack/react-query';

import { fetchTeams, type Team } from '@api-service/teams';

const ONE_HOUR_IN_MS = 60 * 60 * 1000;

export type UseTeamsResult = {
  teams: Team[];
  isLoading: boolean;
  isError: boolean;
};

export const useTeams = (): UseTeamsResult => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['teams'],
    queryFn: fetchTeams,
    staleTime: ONE_HOUR_IN_MS,
    refetchOnWindowFocus: false
  });

  return {
    teams: data ?? [],
    isLoading,
    isError
  };
};
